// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ToastContent-module__Content__CaxnQ {
    display: flex;
    flex-direction: column;
    gap: var(--ds-gap-xs);
    min-width: 0;
}

.ToastContent-module__Label__UmTNl {
    color: var(--ds-toast-label-color);
}

.ToastContent-module__Message__I8rnY {
    color: var(--ds-toast-message-color);
    /* stylelint-disable-next-line property-disallowed-list -- need to overwrite the default line height for paragraphs */
    line-height: var(--ds-line-height);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Content": `ToastContent-module__Content__CaxnQ`,
	"Label": `ToastContent-module__Label__UmTNl`,
	"Message": `ToastContent-module__Message__I8rnY`
};
export default ___CSS_LOADER_EXPORT___;
